import Axios from 'axios';
import { Message } from 'element-ui'
import router from '../router'
import local from '../data/local'
import commonfun from '../common.js'
// cookie
import Cookies from 'js-cookie'

// Axios
const axiosInstance = Axios.create({
    baseURL: (() => {
        if (/dev\.digitalgcp/i.test(location.hostname)) {
            return 'http://dev-api.digitalgcp.com/api';
        } else if (/digitalgcp/i.test(location.hostname)) {
            return 'https://api.digitalgcp.com/api';
        } else if (/localhost|192.168.100.110/i.test(location.hostname)) {
            return '//apitrials.wuxu.com/api';
        }
        return '//apitrials.wuxuwang.com/api';
    })()
})
axiosInstance.interceptors.request.use((config) => {

    let lang = Cookies.get('lang') ? Cookies.get('lang') : 'zh-cn';
    // 添加 token
    config.headers.common.token = local.value.token;
    config.headers.common.tokenid = local.value.uid;
    config.headers.common.lang = lang;

    // 添加毫秒时间戳
    config.start_stamp = Date.now()

    return config;
}, error => {
    return Promise.reject(error);
})

const message_cache = [];
axiosInstance.interceptors.response.use(async (response) => {

    // 请求，需要至少等待 300ms 才能成功
    const use_time = Date.now() - response.config.start_stamp
    if (use_time < 300) {
        await new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, 300 - use_time)
        })
    }

    // 后端数据错误提示
    switch (response.data.state) {
        // 登录成功
        case 40100:
            break;
        // 普通获取数据
        case 0:
            break;
        default:
            if (response?.data?.msg && !message_cache.includes(response?.data?.msg)) {
                Message({
                    type: 'error',
                    message: response.data.msg,
                    duration: 4000,
                })
                message_cache.push(response.data.msg);
                // 保证同样的错误提示，在 500ms 内不重复
                setTimeout(() => {
                    message_cache.splice(message_cache.indexOf(response.data.msg), 1);
                }, 500);
            }
    }

    switch (response?.data?.state) {
        // 请登录
        case 40005:
            if (router.currentRoute.name !== 'index') {
                local.set({
                    id: '',
                    uid: '',
                    token: ''
                });
                return setTimeout(() => {
                    // commonfun.towuxu('logout');
                    location.href = '/';
                }, 1000);
            }
            break;
        case 40007:
            local.set({
                id: '',
                uid: '',
                token: ''
            });
            setTimeout(() => {
                commonfun.towuxu('login');
            }, 1000);
            break;
        case 40010:
            setTimeout(() => {
                location.href = '/'
            }, 1000);
            break;
        case 40102:
        case 404:
            location.href = '/404'
            break;
        // 登录成功
        case 40100:
            break;
    }

    return response.data;
}, error => {
    // http 返回状态
    let status = "";
    if (error.request) {
        status = error.request;
    } else if (error.response) {
        status = error.response;
    }
    if (status) {
        switch (status.status) {
            case 500:
                Message({
                    type: 'error',
                    message: '页面异常，请稍后再试！',
                    duration: 4000,
                })
                break;
        
            default:
                break;
        }
    }
    return false;
    // return Promise.reject(error);
})

export default {
    axios: axiosInstance,
    get(url, data, config) {
        return axiosInstance.get(url, {
            params: data,
            ...config,
        })
    },
    post(url, data, config) {
        return axiosInstance.post(url, data, config)
    },
};